// UserText.tsx
import { IUserId, IUserInfo } from "@home-health-notify/domain";
import { Typography, TypographyProps } from "@mui/material";
import React, { useContext } from "react";
import { UserDirectoryContext } from "hhn-commons";

type Field = "firstName" | "lastName" | "name" | "title";

type Props = {
  userId: IUserId;
  field: Field;
} & TypographyProps;

const UserText = React.memo(function UserText({
  userId,
  field,
  variant = "body1",
  component = "span",
  sx,
  ...rest
}: Props) {
  const { userDirectory } = useContext(UserDirectoryContext);
  const user = userDirectory.getUserInfo(userId);
  const value = (user as IUserInfo)[field];
  const styleSx = {
    whiteSpace: "pre-wrap",
    fontWeight: "medium",
    ...sx,
  };
  return (
    <Typography variant={variant} sx={styleSx} component={component} {...rest}>
      {value}
    </Typography>
  );
});

export const UserFirstName = (p: Omit<Props, "field">) => (
  <UserText {...p} field="firstName" />
);
export const UserLastName = (p: Omit<Props, "field">) => (
  <UserText {...p} field="lastName" />
);
export const UserFullName = (p: Omit<Props, "field">) => (
  <UserText {...p} field="name" />
);
export const UserTitle = (p: Omit<Props, "field">) => (
  <UserText {...p} field="title" />
);
